import type {
  Attribute, AttributeComponent, AttributeComponentDefinition, DataRoute, Threshold,
  ThresholdLeft,
  ThresholdRight,
} from '../../../store/engine/types/schema';
import type { MLAAttributeItemOrigin } from '../NodeEditorDrawer/types';

export const CREATABLE_MLA_DROPDOWN_DATA_TYPES = [
  'csv',
  'integer',
  'boolean',
];

export type AttributeDescriptionTokens = {
  string: string;
  isOptional: boolean;
  caretIndex: number;
}[];

export type MLASourceData = {
  type: MLAAttributeItemOrigin;
  data: Threshold | DataRoute;
  attributeTokenMap: {
    descTokens: AttributeDescriptionTokens;
    components: AttributeComponent[];
    attributeDataPath: string;
    attribute: Attribute;
  };
};

export type RulesWithMLA = {
  type: 'thresholdLeft' | 'thresholdRight' | 'dataRoute';
  publicId: string;
  data: ThresholdLeft | ThresholdRight | DataRoute;
}[];

export type PresentationalToken = {
  label: string;
  placeholder: string;
  isOptional: boolean;
  component: AttributeComponentDefinition;
  value: string | number | (string | number)[];
};
